import { Brand } from '@awaze/design-system.components.awaze-theme-provider'

const modifyPropertyForUndatedVariants = <
  PropertyGeneric extends {
    wasPrice?: number | null
    startDate?: string | null
  },
>(
  propertyObject: PropertyGeneric,
  variant: string | undefined,
  isDatedSearch: boolean,
  brand: Brand,
): PropertyGeneric => {
  const newPropertyObject = { ...propertyObject }

  if (variant === 'off') {
    if (!isDatedSearch && (brand === 'cottages.com' || brand === 'hoseasons')) {
      delete newPropertyObject.wasPrice
      delete newPropertyObject.startDate
    }
  }

  switch (variant) {
    case 'variant_a':
      delete newPropertyObject.wasPrice
      delete newPropertyObject.startDate
      break
    case 'variant_b':
      delete newPropertyObject.startDate
      break
    case 'variant_d':
      delete newPropertyObject.wasPrice
      break
  }

  return newPropertyObject
}

export { modifyPropertyForUndatedVariants }
